import React, { useEffect } from 'react';
import './contratistas.css';

const Contratistas   = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container transparencia-container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h1 className='title'>Padrón de Contratistas</h1>
          <hr className='hr-gob'/>
        </div>

        <div className='col-md-4 col-12 ofiprov-card'>
          <img src="/assets/imgs/contratistas/Requisitos Contratista Inscripción.png" alt="Proveedores y Contratistas" className='ofiprov-img' />
          <h2 className='ofiprov-subtitle'>Requisitos Contratista Inscripción</h2>
          <div className='ofiprov-links'>
            <a href="https://s-contraloria.hidalgo.gob.mx/interes/contra_proveedores/julio/REQUISITOS CONTRATISTA INSCRIPCION OFICINA VIRTUAL.pdf" target="_blank" rel="noopener noreferrer" 
            className='btn-oficina'>Ir al Servicio</a>
            {/* <a href="https://ruts.hidalgo.gob.mx/ver/392" target="_blank" rel="noopener noreferrer" className='btn-oficina'>Requisitos</a> */}
            {/* <span className='btn-oficina btn-oficina--red'>Video Tutorial</span> */}
          </div>
        </div>


          <div className='col-md-4 col-12 ofiprov-card'>
          <img src="/assets/imgs/contratistas/Requisitos Contratista Ampliación.png" alt="Sancionados" className='ofiprov-img' />
          <h2 className='ofiprov-subtitle'>Requisitos Contratista Ampliación</h2>
          <div className='ofiprov-links'>
            <a href="https://s-contraloria.hidalgo.gob.mx/interes/contra_proveedores/julio/REQUISITOS CONTRATISTA MODIFICACIÓN OFICINA VIRTUAL.pdf" target="_blank" rel="noopener noreferrer" 
            className='btn-oficina'>Ir al Servicio</a>
            {/* <a href="https://ruts.hidalgo.gob.mx/ver/1602" target="_blank" rel="noopener noreferrer" className='btn-oficina'>Requisitos</a>
            <span className='btn-oficina btn-oficina--red'>Video Tutorial</span> */}
          </div>
        </div>


        <div className='col-md-4 col-12 ofiprov-card'>
          <img src="/assets/imgs/contratistas/Requisitos Contratista Revalidación.png" alt="Proveedores" className='ofiprov-img' />
          <h2 className='ofiprov-subtitle'>Requisitos Contratista Revalidación</h2>
          <div className='ofiprov-links'>
            
             <a href="https://s-contraloria.hidalgo.gob.mx/interes/contra_proveedores/julio/REQUISITOS CONTRATISTA REVALIDACION OFICINA VIRTUAL.pdf" target="_blank" rel="noopener noreferrer" 
           

        
           className='btn-oficina'>Ir al Servicio</a>
            {/* <a href="https://ruts.hidalgo.gob.mx/ver/409" target="_blank" rel="noopener noreferrer" className='btn-oficina'>Requisitos</a>
            <span className='btn-oficina btn-oficina--red'>Video Tutorial</span>  */}
          </div>
        </div>


        <div className='col-md-4 col-12 ofiprov-card'>
         <img src="/assets/imgs/contratistas/Aviso de Privacidad Contratista.png" alt="Proveedores" className='ofiprov-img' />
          <h2 className='ofiprov-subtitle'>Aviso de Privacidad Contratista</h2>
          <div className='ofiprov-links'>
            
             <a href="https://s-contraloria.hidalgo.gob.mx/interes/contra_proveedores/julio/Aviso de Privacidad Simplificado.docx" target="_blank" rel="noopener noreferrer" 
           

        
           className='btn-oficina'>Ir al Servicio</a>
            {/* <a href="https://ruts.hidalgo.gob.mx/ver/409" target="_blank" rel="noopener noreferrer" className='btn-oficina'>Requisitos</a>
            <span className='btn-oficina btn-oficina--red'>Video Tutorial</span>  */}
          </div>
        </div>


        <div className='col-md-4 col-12 ofiprov-card'>
          <img src="/assets/imgs/contratistas/Carta bajo protesta de decir verdad.png" alt="Proveedores" className='ofiprov-img' />
          <h2 className='ofiprov-subtitle'>Carta Bajo Protesta de Decir Verdad</h2>
          <div className='ofiprov-links'>
            
             <a href="https://s-contraloria.hidalgo.gob.mx/interes/contra_proveedores/julio/CARTA BAJO PROTESTA DE DECIR VERDAD PERSONA FISICA.docx" target="_blank" rel="noopener noreferrer" 
           

        
           className='btn-oficina'>Ir al Servicio</a>
            {/* <a href="https://ruts.hidalgo.gob.mx/ver/409" target="_blank" rel="noopener noreferrer" className='btn-oficina'>Requisitos</a>
            <span className='btn-oficina btn-oficina--red'>Video Tutorial</span>  */}
          </div>
        </div>


         <div className='col-md-4 col-12 ofiprov-card'>
          <img src="/assets/imgs/contratistas/Carta Bajo Protesta Decir Verdad Socio.png" alt="Proveedores" className='ofiprov-img' />
          <h2 className='ofiprov-subtitle'>Carta Bajo Protesta Decir Verdad Socio </h2>
          <div className='ofiprov-links'>
            
             <a href="https://s-contraloria.hidalgo.gob.mx/interes/contra_proveedores/julio/CARTA BAJO PROTESTA DE DECIR VERDAD SOCIO.docx" target="_blank" rel="noopener noreferrer" 
           

        
           className='btn-oficina'>Ir al Servicio</a>
            {/* <a href="https://ruts.hidalgo.gob.mx/ver/409" target="_blank" rel="noopener noreferrer" className='btn-oficina'>Requisitos</a>
            <span className='btn-oficina btn-oficina--red'>Video Tutorial</span>  */}
          </div>
        </div>

        <div className='col-md-4 col-12 ofiprov-card'>
          <img src="/assets/imgs/contratistas/Carta bajo protesta de decir verdad representante legal contratista.png" alt="Proveedores" className='ofiprov-img' />
          <h2 className='ofiprov-subtitle'>Carta Bajo Protesta de Decir Verdad Representante Legal Contratista </h2>
          <div className='ofiprov-links'>
            
             <a href= "https://s-contraloria.hidalgo.gob.mx/interes/contra_proveedores/julio/CARTA BAJO PROTESTA DE DECIR VERDAD REPRESENTANTE LEGAL.docx" target="_blank" rel="noopener noreferrer" 
           

        
           className='btn-oficina'>Ir al Servicio</a>
            {/* <a href="https://ruts.hidalgo.gob.mx/ver/409" target="_blank" rel="noopener noreferrer" className='btn-oficina'>Requisitos</a>
            <span className='btn-oficina btn-oficina--red'>Video Tutorial</span>  */}
          </div>
        </div>

        <div className='col-12 ofiprov-contact'>
          <div className='ofiprov-contact-box'>
            <p>Para cualquier consulta, ponemos a su disposición los siguientes medios de contacto en horario laboral, de 9:00 a.m. a 5:00 p.m.:</p>
            <p><strong>Correo electrónico:</strong> <a href="mailto:agenda.padron@hidalgo.gob.mx">agenda.padron@hidalgo.gob.mx</a></p>
        
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contratistas ;
